import {
  insertImageFromComputer,
  stampSignedIdAttributes,
  uploadPendingDataImages
} from './editorImages'
import { replaceBlobUrisWithDataUrls } from './uploadImage'
import { DYNAMIC_TAGS } from './dynamicTags'
import { COLORS } from '../../utilities/constants'

function getApiOrigin () {
  const apiUrl = process.env.REACT_APP_NEW_API_URL
  if (!apiUrl) return ''

  try {
    return new URL(apiUrl).origin
  } catch {
    return ''
  }
}

const API_ORIGIN = getApiOrigin()
const IMG_SRC_POLICY = API_ORIGIN
  ? `'self' data: blob: ${API_ORIGIN}`
  : "'self' data: blob:"

function setupEditor (editor) {
  editor.on('PastePostProcess', (event) => {
    replaceBlobUrisWithDataUrls(editor, event.node)
  })

  editor.on('SetContent Change PastePostProcess', () => {
    replaceBlobUrisWithDataUrls(editor, editor.getBody())
    stampSignedIdAttributes(editor)
    uploadPendingDataImages(editor)
  })

  editor.ui.registry.addButton('insertImage', {
    icon: 'image',
    tooltip: 'Insert image',
    onAction: () => insertImageFromComputer(editor)
  })

  editor.ui.registry.addMenuButton('dynamicTags', {
    text: 'Tags',

    fetch: (callback) => {
      const bookmark = editor.selection.getBookmark(
        2,
        true
      )

      callback(
        DYNAMIC_TAGS.map(tag => ({
          type: 'menuitem',
          text: tag.text,

          onAction: () => {
            editor.focus()
            editor.selection.moveToBookmark(bookmark)
            editor.insertContent(`
              <span
                class="dynamic-tag"
                data-tag="${tag.key}"
                contenteditable="false"
              >[${tag.text}]</span>&nbsp;
            `)
          }
        }))
      )
    }
  })
}

export const EDITOR_INIT = {
  height: 320,

  menubar: false,
  branding: false,
  promotion: false,
  statusbar: false,

  license_key: 'gpl',
  skin: false,
  content_css: false,

  plugins: 'lists code',

  toolbar:
    'bold italic underline bullist numlist insertImage dynamicTags',

  formats: {
    underline: { inline: 'u', exact: true }
  },

  automatic_uploads: false,
  paste_data_images: true,
  convert_urls: false,
  relative_urls: false,
  sandbox_iframes: true,
  entity_encoding: 'raw',
  images_file_types: 'jpeg,jpg,jpe,jfi,jif,jfif,png,gif,bmp,webp',
  content_security_policy:
    "default-src 'none'; script-src 'none'; style-src 'unsafe-inline' 'self' blob:; " +
    `img-src ${IMG_SRC_POLICY}; font-src 'self' data:; connect-src 'none'; ` +
    "object-src 'none'; frame-src 'none'; base-uri 'none'; form-action 'none';",
  placeholder: 'Write your Agreement here...',
  content_style: `
    html {
      font-size: 0.6rem;
    }

    body {
      font-family: inherit;
      font-size: 1.6rem;
      line-height: 1.5;
    }

    img {
      max-width: 100%;
      height: auto;
    }

    .dynamic-tag {
      display: inline-block;
      padding: 0.2rem 0.7rem;
      margin: 0 0.2rem;
      color: ${COLORS.TERTIARY};
      border-radius: 0.4rem;
      font-weight: 500;
      cursor: default;
      user-select: none;
      white-space: nowrap;
    }
  `,
  setup: setupEditor
}
